export const SOCKET_EXCEPTIONS = {
  GUEST_CONTENT_LIMIT: "GUEST_CONTENT_LIMIT",
	TEXT_TOO_LONG: "TEXT_TOO_LONG",
	DAILY_SYMBOLS_LIMIT: "DAILY_SYMBOLS_LIMIT",
	DAILY_SECONDS_LIMIT: "DAILY_SECONDS_LIMIT",
	UNSUPPORTED_FILE_TYPE: "UNSUPPORTED_FILE_TYPE",
	SOMETHING_WENT_WRONG: "SOMETHING_WENT_WRONG",
}

export const SOCKET_RESPONSES = {
	CONTENT_EXCEPTION: "CONTENT_EXCEPTION",
	CONTENT_RESPONSE: "CONTENT_RESPONSE",
	CONTENT_TEXT_LENGTH: "CONTENT_TEXT_LENGTH",
	MAX_TEXT_QUESTION: "MAX_TEXT_QUESTION",
	EMPTY_IMAGE_OCR: "EMPTY_IMAGE_OCR",
	CLIENT_PASSED_INFO: "CLIENT_PASSED_INFO",
	ALREADY_PROCESSING: "ALREADY_PROCESSING",

	CONTENT_FIRST_CHUNK_COMPLETED: 'CONTENT_FIRST_CHUNK_COMPLETED',
	CONTENT_NEW_CHUNK_COMPLETED: 'CONTENT_NEW_CHUNK_COMPLETED',
	// Word timestamps for a chunk published with wordsReady=false landed
	// (ok) or never will (ok=false). Payload: { contentId, audioChunkIdx, ok }.
	CONTENT_CHUNK_WORDS_COMPLETED: 'CONTENT_CHUNK_WORDS_COMPLETED',
	CONTENT_CREATION_FINISHED: 'CONTENT_CREATION_FINISHED',
}

export const SOCKET_ROUTES = {
	CONTENT_FROM_URL: "content-from-url",
	HANDLE_LONG_TEXT: "handle-long-text",
}
